export const iconFontAwesomeAlertExclamation = (
	<i className="fa-solid fa-exclamation"></i>
);
